import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import { createNavigationConfig } from 'loankeeper-common/components'

export * from './selectors'
export * from './actions'

export const createApplicationSearchNavigationItem = createNavigationConfig((translateFn) => ({
  icon: 'application_search',
  text: translateFn('mnu_application_view'),
  identity: '/secure/application/search',
  permission: 'VIEW_APPLICATION',
}))

export default Loadable(() => import('./Components'))
